<template>
  <div>
    <a-form :form="form" id="form">
      <template v-if="mode == 'Create'">
        <a-form-item label="Note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="4"
            v-decorator="['catatan', { initialValue: initialData.catatan }]"
          />
        </a-form-item>
        <a-form-item
          :label="(item.actor ? item.actor :'')+' '+item.jenis"
          v-for="(item, index) in lisAppr"
          :key="index"
        >
          <template v-if="item.nama == '-'">
            <a-select
              v-decorator="[
                item.actor ? (item.actor.replace(/\s/g, '').toLowerCase()) : 'empty',
                {
                  rules: [{ required: true }],
                },
              ]"
            >
              <a-select-option
                v-for="item in approval"
                :key="item.value"
                :value="item.value"
                >{{ item.text }}</a-select-option
              >
            </a-select>
          </template>
          <a-input
            disabled
            v-else
            v-decorator="[
              item.actor ? item.actor.replace(/\s/g, '').toLowerCase() : 'empty',
              {
                rules: [{ required: false }],
                initialValue: item.nama,
                key: item.tlc,
              },
            ]"
          ></a-input>
        </a-form-item>
      </template>
      <template v-else>
        <a-form-item label="Note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="4"
            v-decorator="['catatan', { initialValue: initialData.catatan }]"
          />
        </a-form-item>
        <a-row
          class="group-flex"
          v-for="item in lisAppr"
          :key="item.tlc"
        >
          <a-col span="6">
            <label>{{ item.actor }} {{ item.jenis }}</label>
          </a-col>
          <a-col span="1">:</a-col>
          <a-col
            ><a-tag>{{ item.nama }}</a-tag></a-col
          >
        </a-row>
      </template>
    </a-form>
    <!-- <a-row
      class="group-flex"
      v-for="item in collectData.approval"
      :key="item.tlc"
    >
      <a-col span="6">
        <h4>{{ item.actor }} Approval</h4>
      </a-col>
      <a-col span="1">:</a-col>
      <a-col
        ><span>{{ item.name }}</span></a-col
      >
    </a-row> -->
    <br/>
    <span v-if="getScreen"> Is Data Completed ? &nbsp; </span>
    <a-switch v-if="getScreen" v-model="checkCompleted" size="small"
        checked-children="Yes" un-checked-children="No" :disabled="
        dataList.length <= 1 && mode === 'Edit' && type === 'revised'
      "
      @change="handleCheckData"/>
    <!-- <a-checkbox
      v-if="getScreen"
      v-model="checkCompleted"
      :disabled="
        dataList.length <= 1 && mode === 'Edit' && type === 'revised'
      "
      @change="handleCheckData"
    >Is Data Completed ?</a-checkbox> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

export default {
  props: ["mode","collectData","dataList","lisAppr"],
  name: "Persetujuan",
  data() {
    return {
      form: this.$form.createForm(this),  
      checkCompleted: false,    
    };
  },
  created() {
    // this.FETCH_GA();
    // this.FETCH_VPM();
    if (this.getScreen && this.mode === "Edit" && this.type === "revised") {
      this.checkCompleted = true;
    }
  },
  computed: {
    ...mapGetters(["getScreen","getAtasan", "getAuth", "getAllBOD", "getGA", "getVPM"]),
    initialData: function () {
      if (this.collectData.informasi === undefined || this.collectData.informasi.length <= 0) {
        return {
          catatan: "",
        };
      } else {
        return {
          catatan: this.collectData.informasi.catatan,
        };
      }
    },
  },
  mounted() {
    if (this.mode !== "Edit") {
      this.getComboApproval().then((res) => {
        this.approval = res.data.approval;
      });
    }
  },
  methods: {
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        Event.$emit("kDirekturInformasi", { note: values.catatan });
      });
    },
    async getComboApproval() {
      return await axios({
        method: "get",
        url: this.$serviceUrl + "pp/approval_combo_v2",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      });
    },
    handleCheckData() {
      Event.$emit("ismobileSaveLapumpp", { target: {checked : this.checkCompleted } });
    }
  },
};
</script>

<style lang="less">
.group-flex {
  display: flex;
  margin-top: @margin / 2;
}
</style>
